import { MainLayout } from "app/layout/main/MainLayout";
import { RouterSuspenseFallback } from "app/tools/router/components/RouterSuspenseFallback";
import { RouterRoutesSettings } from "app/tools/router/types";
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router";

import { useVariableExpenseRoutes } from "./VariableExpense/routes";

export enum FinanceRoutes {
  DASHBOARD = "/finance/dashboard",
  VARIABLE_EXPENSES = "/finance/variable-expenses",
  VARIABLE_EXPENSES_ADD = "/finance/variable-expenses/add",
  VARIABLE_EXPENSES_EDIT = "/finance/variable-expenses/edit/:id",
}

export const useFinanceRoutes = (): RouterRoutesSettings => {
  const variableExpenseRoutes = useVariableExpenseRoutes();

  return {
    authenticatedOnly: [
      {
        children: [
          {
            children: [
              {
                element: <Navigate replace={true} to="dashboard" />,
                index: true,
              },
              {
                HydrateFallback: () => null,
                lazy: async () => {
                  const { DashboardPage } = await import("./Dashboard/page");
                  return { Component: DashboardPage };
                },
                path: "dashboard",
              },
              ...(variableExpenseRoutes.authenticatedOnly ?? []),
            ],
            path: "finance",
          },
        ],
        element: (
          <MainLayout>
            <Suspense fallback={<RouterSuspenseFallback />}>
              <Outlet />
            </Suspense>
          </MainLayout>
        ),
      },
    ],
    public: [...(variableExpenseRoutes.public ?? [])],
  };
};
